import React from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import "./AboutMe.css";

export default function AboutMe(props) {
  const SCREEN_CONSTANTS = {
    description:
      "More than 3 years of practicing programming and coding skills, working as a front-end web developer, analyzing and structuring systems to develop web applications using variety of tools, libraries, frameworks, and programming languages to solve real life problems.",
    highlights: {
      bullets: [
        "HTML5 & CSS3",
        "JavaScript",
        "React & Hooks & Redux",
        "Firebase & Firestore",
        "Material UI",
        "Bootstrap",
        "Git and GitHub",
      ],
      heading: "Technologies",
    },
  };

  const renderHighlight = () => {
    return SCREEN_CONSTANTS.highlights.bullets.map((value, i) => (
      <div className='highlight' key={i}>
        <div className='highlight-blob'></div>
        <span>{value}</span>
      </div>
    ));
  };

  return (
    <div className='about-me-container screen-container' id='aboutMe'>
      <div className='about-me-parent' id={props.id || ""}>
        <ScreenHeading title={"About Me"} subHeading={"Why choose me?"} />
        <div className='about-me-card'>
          <div className='about-me-profile'></div>
          <div className='about-me-details'>
            <span className='about-me-description'>
              {SCREEN_CONSTANTS.description}
            </span>
            <div className='about-me-highlights'>
              <div className='highlight-heading'>
                <span>{SCREEN_CONSTANTS.highlights.heading}</span>
              </div>
              {renderHighlight()}
            </div>
            <div className='about-me-options'>
              <a href='#contactMe' className='btn primary-btn button'>
                Hire Me
              </a>
              <a
                target='_blank'
                rel='noreferrer'
                href='https://drive.google.com/file/d/1sUX4kShhhst6RJT5ufRIPxxzkzgZwSKr/view?usp=sharing'
                download='Monzer Resume'
              >
                <button className='btn highlighted-btn'>Get Resume</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
